import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../../Containers/Config/index.js';
import { UPDATE_SERVICE_WORTH, UPDATE_SERVICE_WORTH_SUCCESS, UPDATE_SERVICE_WORTH_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* updateServiceWorth({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/assign-coins`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
      params: {
        objectId: payload.data.objectId,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`Updated Successfully`);
      yield put({
        type: UPDATE_SERVICE_WORTH_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_SERVICE_WORTH_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_SERVICE_WORTH_ERROR, payload: error });
  }
}

export function* watchUpdateServiceWorth() {
  yield takeEvery(UPDATE_SERVICE_WORTH, updateServiceWorth);
}

function* updateServiceWorthSaga() {
  yield all([fork(watchUpdateServiceWorth)]);
}

export default updateServiceWorthSaga;
